<template>
  <el-select v-model="selectValue" :placeholder="$t('221')" @change="change" :clearable="clearable">
    <el-option v-for="item in options" :key="item.id" :label="item.job_title_name" :value="item.id"> </el-option>
  </el-select>
</template>

<script>
/* eslint-disable */
// 接口api
import { getAllListFn } from 'api/org/position'
export default {
  model: {
    prop: ['value']
  },
  props: {
    value: Number | String,
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: [],
      selectValue: ''
    }
  },
  created() {
    getAllListFn().then(res => {
      this.options = res.data
    })
  },
  methods: {
    change(v) {
      this.$emit('input', v)
    }
  }
}
</script>
